import { render, staticRenderFns } from "./CardWorkerSatisfaction.vue?vue&type=template&id=0c37cfa3&scoped=true&"
import script from "./CardWorkerSatisfaction.vue?vue&type=script&lang=js&"
export * from "./CardWorkerSatisfaction.vue?vue&type=script&lang=js&"
import style0 from "./CardWorkerSatisfaction.vue?vue&type=style&index=0&id=0c37cfa3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c37cfa3",
  null
  
)

export default component.exports